export default __webpack_public_path__ + "static/media/star.ece7e053.svg";